///<reference path="../common/smart-mover.models.ts"/>
///<reference path="../../../baseClasses/dataMaintenance.interface.ts"/>
///<reference path="../../../../plugins/reports/reports.models.ts"/>
///<reference path="../common/collection-api.ts"/>


module Meevo.Components.Controls.SmartMover {
    import GenderEnum = Meevo.Model.GenderEnum;
    import ObjectStateEnum = Meevo.Model.ObjectStateEnum;
    import IReportEmployee = Meevo.Plugins.Reports.IReportEmployee;

    export class ReportEmployeesCollection extends SmartMoverApiCollection<IReportEmployee> implements IApiCollection<IReportEmployee> {

        protected get url() {
            return 'Report/Employee';
        }

        protected get smartMoverHiddenValue() {
            return this.options.hiddenValue != null ? this.options.hiddenValue : SmartMoverHiddenValue.EmptyArray;
        }

        constructor(connectedModel: ModelValueType[], items: IReportEmployee[] = [], options: ICollectionOptions<IReportEmployee> = {}) {
            super(connectedModel, items, options);

            this.updateCriteria({
                hierarchyId: null,
                branchId: null,
                objectStateEnumList: [ObjectStateEnum.Active, ObjectStateEnum.Inactive],
                employeeCategoryList: [],
                genderEnumList: [GenderEnum.Male, GenderEnum.Female, GenderEnum.Other, GenderEnum.NotSpecified],
                displayName: null,
                fieldOrderBy: 'DisplayName',
                orderAscDesc: 'Ascending'
            });
        }
    }

}
